export const roundNum = num => {
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const arrSum = arr => arr.reduce((a, b) => Number(a) + Number(b), 0);

export const convertKgsToLbs = kgs => 2.20462 * kgs;

export const randomInt = max => Math.floor(Math.random() * max);
